module.exports = __webpack_public_path__ + "img/ring_g_0_0_1.165c586f.png";